const makeRules = ({
  t,
  required = false,
  requiredKey,
  pattern,
  patternKey,
}) => {
  const rules = [];

  if (required) {
    rules.push({
      required: true,
      whitespace: true,
      message: t(requiredKey),
    });
  }

  if (pattern && patternKey) {
    rules.push({
      pattern,
      message: t(patternKey),
    });
  }

  return rules;
};

export const cleanArabicInput = (value = "") =>
  String(value).replace(/[^\u0600-\u06FF\s]/g, "");

export const arabicNameRules = (
  t,
  required = false,
  requiredKey = "validate_arabic_name_required",
) =>
  makeRules({
    t,
    required,
    requiredKey,
    pattern: /^[\u0600-\u06FF\s]+$/,
    patternKey: "arabic_only_validation",
  });

export const saVatNumberRules = (
  t,
  required = false,
  requiredKey = "validate_vat_number_required",
) =>
  makeRules({
    t,
    required,
    requiredKey,
    pattern: /^3\d{13}3$/,
    patternKey: "validate_sa_vat_number",
  });

export const postalCodeRules = (
  t,
  required = false,
  requiredKey = "validate_postal_code_required",
) =>
  makeRules({
    t,
    required,
    requiredKey,
    pattern: /^\d{5}$/,
    patternKey: "validate_postal_code_5digits",
  });

export const fourDigitNumberRules = (
  t,
  required = false,
  requiredKey,
  patternKey,
) =>
  makeRules({
    t,
    required,
    requiredKey,
    pattern: /^\d{4}$/,
    patternKey,
  });
